module.exports = __webpack_public_path__ + "img/1620744381.006320fa.jpg";